import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { SideBar } from '../Common/SideBar';
import { DashboardHeader } from '../Common/DashboardHeader';
import { Footer } from '../Common/Footer';
import { Header } from '../Common';
import BuyerEstimationTransaction from '../../Models/buyerEstimationTransaction';
import { Spinner } from 'reactstrap';
// import { connect } from 'react-redux';
// import { buyerLogin } from '../../../Action/login';

class SellerBuyerEstimate extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert(this.props.t('0'))
            this.props.history.push('/login/seller');
        };
        var logged_user = JSON.parse(window.localStorage.getItem('info'));
        var id = logged_user.id;
        this.state = {
            minHeight: "475px",
            user: id,
            estimations: [],
            status: ''
        };
        this.getResponseAll();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    getResponseAll() {
        BuyerEstimationTransaction.getMyEstimations(this.state.user).then(res => {
            console.log(res.data)
            this.setState({ estimations: res.data.payload, status: res.data.status })
        })
    }

    sellerEstimation() {
        if (this.state.status === 200) {
            if (this.state.estimations === '' || this.state.estimations === null || this.state.estimations.length === 0) {
                return (
                    <div>
                        <div className="mt-3"><span><img alt="" src={require("../../assets/images/edit.png")} height="40" width='40' />&nbsp;&nbsp;</span></div>
                        <div className="mt-3"><span>{this.props.t('1')}!</span></div>
                    </div>
                )
            } else {
                return (
                    <div style={{ backgroundColor: "white", minHeight: "550px", textAlign: "left" }}>
                        <div className="col-md-12 row ml-2" style={{ paddingTop: "3%", paddingBottom: "2%" }}>
                            <div className="col-md-4 font_12">
                                <b><i>{this.props.t('7')}</i></b>
                            </div>
                            <div className="col-md-2 font_12">
                                <b><i>{this.props.t('8')}</i></b>
                            </div>
                            <div className="col-md-2 font_12">
                                <b><i>{this.props.t('9')}</i></b>
                            </div>
                            <div className="col-md-2 font_12">
                                <b><i>{this.props.t('24')}</i></b>
                            </div>
                            <div className="col-md-2 font_12">
                                <b><i></i></b>
                            </div>
                        </div>
                        {this.state.estimations.map((req, i = 1) =>
                            <div className="col-md-12 row ml-2" key={req.id} style={{ borderBottom: "1px solid #fbf8f8", paddingTop: "3%", paddingBottom: "2%" }}>
                                <div className="col-md-4 font_12">
                                    {/* <span className="font_12">{this.props.t('10')}ID: {req.id}</span><br /> */}
                                    <Link to={{
                                        pathname: `/buyer-request-estimation-details`,
                                        state: {
                                            id: req.id
                                        }
                                    }}>
                                        <b>{req.title}</b>
                                    </Link>

                                </div>
                                <div className="col-md-2 font_12" style={{}}>
                                    {(JSON.stringify(req.application_date)).substring(1, 11)}
                                </div>
                                <div className="col-md-2 font_12" style={{}}>
                                    {req.budget_range}
                                </div>
                                <div className="col-md-2">
                                    {(() => {
                                        if (req.current_status === 'TRADING') {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}> {this.props.t('16')}</div>
                                            )
                                        } else if (req.current_status === 'UNDERESTIMATION') {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('17')}</div>
                                            )
                                        } else if (req.current_status === 'COMPLETE') {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('25')}</div>
                                            )
                                        } else if (req.current_status === 'CANCEL') {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('5')}</div>
                                            )
                                        } else if (req.current_status === 'DECLINED') {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('26')}</div>
                                            )
                                        } else {
                                            return (
                                                <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('27')}</div>
                                            )
                                        }
                                    })()}
                                </div>
                                <div className="col-md-2 font_12">
                                    <Link to={{
                                        pathname: `/seller-direct-message`,
                                        state: {
                                            buyer_id: req.buyer_id,
                                            seller_id: req.accepted_seller_id
                                        }
                                    }}>
                                        <button
                                            style={{
                                                padding: "10%", border: "1px solid cadetblue",
                                                borderRadius: "4px", color: "green", background: "white"
                                            }}>
                                            {this.props.t('11')}
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        )}
                    </div>
                )
            }
        } else {
            return (
                <div className="container-fluid">
                    <div className="container">
                        <div className="" style={{ height: '100px' }}></div>
                        <div className="text-center mt-3">
                            <Spinner color="primary" size="150" />
                        </div>
                    </div>
                </div>
            )
        }
    }

    sellerEstimationSmall() {
        if (this.state.status === 200) {
            if (this.state.estimations === '' || this.state.estimations === null || this.state.estimations.length === 0) {
                return (
                    <div>
                        <div className="mt-3"><span><img alt="" src={require("../../assets/images/edit.png")} height="40" width='40' />&nbsp;&nbsp;</span></div>
                        <div className="mt-3"><span>{this.props.t('1')}!</span></div>
                    </div>
                )
            } else {
                return (
                    <div style={{ backgroundColor: "white", minHeight: "550px", textAlign: "left" }}>
                        {this.state.estimations.map((req, i = 1) =>
                            <div className="ml-2 pl-1" key={req.id} style={{ borderBottom: "1px solid #dadada", paddingTop: "3%", paddingBottom: "3%" }}>
                                <div className="font_12 pb-3" style={{paddingLeft: "15px"}}>
                                    {/* <span className="font_12">{this.props.t('10')}ID: {req.id}</span><br /> */}
                                    <Link to={{
                                        pathname: `/buyer-request-estimation-details`,
                                        state: {
                                            id: req.id
                                        }
                                    }}>
                                        <b class="gray">{req.title}</b>
                                    </Link>
                                </div>
                                <div className="font_12 row col" style={{}}>
                                    <div className="col-4 text-left">{req.budget_range}</div>
                                    <div className="col-4 text-right remove_pads">{(JSON.stringify(req.application_date)).substring(1, 11)}</div>
                                    <div className="col-4 text-right pr-1">
                                        {(() => {
                                            if (req.current_status === 'TRADING') {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}> {this.props.t('16')}</div>
                                                )
                                            } else if (req.current_status === 'UNDERESTIMATION') {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('17')}</div>
                                                )
                                            } else if (req.current_status === 'COMPLETE') {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('25')}</div>
                                                )
                                            } else if (req.current_status === 'CANCEL') {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('5')}</div>
                                                )
                                            } else if (req.current_status === 'DECLINED') {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('26')}</div>
                                                )
                                            } else {
                                                return (
                                                    <div style={{ borderRdius: "8px", backgroundColor: "white", color: "green", fontSize: "10px" }}>{this.props.t('27')}</div>
                                                )
                                            }
                                        })()}
                                    </div>
                                </div>
                                <div className="col-12">&nbsp;</div>
                                <div className="font_12 text-center">
                                    <Link to={{
                                        pathname: `/seller-direct-message`,
                                        state: {
                                            buyer_id: req.buyer_id,
                                            seller_id: req.accepted_seller_id
                                        }
                                    }}>
                                        <button
                                            style={{
                                                padding: "1%", border: "1px solid cadetblue",
                                                borderRadius: "4px", color: "green", background: "white"
                                            }}>
                                            {this.props.t('11')}
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        )}
                    </div>
                )
            }
        } else {
            return (
                <div className="container-fluid">
                    <div className="container">
                        <div className="" style={{ height: '100px' }}></div>
                        <div className="text-center mt-3">
                            <Spinner color="primary" size="150" />
                        </div>
                    </div>
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //for mobile responsive
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="mt-5 input_name big_font text-left" style={{ width: "100%" ,fontSize:'20px'}}>
                                    {this.props.t('14')}
                                </div>
                                <div className="chest" style={{fontSize:'13px'}}>
                                    <div>
                                        <div className="row" style={{ marginLeft: '0px', marginRight: '-8px' }}>
                                            <div className="navigation" style={{ width: "33%",paddingRight:'3%', fontSize: "9px" , borderTop: "4px solid #67b1e2", borderBottom: "1px solid white" }}>
                                                <Link to={'/seller-buyer-estimate'} className="h-a" href=""><b>{this.props.t('20')}</b></Link>
                                            </div>
                                            <div className="navigation" style={{ width: "33%" ,paddingRight:'3%', fontSize: "9px" }}>
                                                <Link to={'/seller-buyer-transaction'} className="h-a" href="">{this.props.t('16')}</Link>
                                            </div>
                                            <div className="navigation" style={{ width: "32%",paddingRight:'2%', fontSize: "9px"  }}>
                                                <Link to={'/seller-buyer-complete-cancel'} className="h-a" href="">{this.props.t('3')}</Link>
                                            </div>
                                        </div>

                                        <div>
                                            <div colSpan="3">
                                                <div className="min-height">
                                                    {this.sellerEstimationSmall()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font text-left" style={{ width: "100%" }}>
                                            {this.props.t('14')}
                                    </div>
                                        <div className="chest">
                                            <div>
                                                <div className="row" style={{ marginLeft: '0px', marginRight: '-8px' }}>
                                                    <div className="navigation" style={{ width: "33%", borderTop: "4px solid #67b1e2", borderBottom: "1px solid white" }}>
                                                        <Link to={'/seller-buyer-estimate'} className="h-a" href=""><b>{this.props.t('20')}</b></Link>
                                                    </div>
                                                    <div className="navigation" style={{ width: "33%" }}>
                                                        <Link to={'/seller-buyer-transaction'} className="h-a" href="">{this.props.t('16')}</Link>
                                                    </div>
                                                    <div className="navigation" style={{ width: "33%" }}>
                                                        <Link to={'/seller-buyer-complete-cancel'} className="h-a" href="">{this.props.t('3')}</Link>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div colSpan="3">
                                                        <div className="min-height">
                                                            {this.sellerEstimation()}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
    }
}

// const mapStateToProps = (state) => ({
//     buyerLogin: state.buyerLogin,
// });

// BuyerLogin = connect(mapStateToProps, { buyerLogin })(BuyerLogin);

export { SellerBuyerEstimate };


 SellerBuyerEstimate = withTranslation('src_Components_Transactions_SellerBuyerEstimate')(SellerBuyerEstimate);